<template>
    <div class="page-container">
        <site-header />
        <div class="main-content">
            <div class="e-certificate">
                <h1>电子证书</h1>
                <div class="certificate-list">
                    <el-card v-if="certificates.length > 0" class="certificate-card">
                        <div class="certificate-info">
                            <div class="info-item">
                                <span class="label">证书编号：</span>
                                <span class="value">{{ certificates[0].certificateNumber }}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">姓名：</span>
                                <span class="value">{{ certificates[0].name }}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">身份证号：</span>
                                <span class="value">{{ certificates[0].idCard }}</span>
                            </div>
                            <div class="info-item">
                                <span class="label">发证时间：</span>
                                <span class="value">{{ certificates[0].createTime }}</span>
                            </div>
                        </div>
                        <div class="certificate-preview">
                            <iframe v-if="certificates[0].certificateUrl" :src="certificates[0].certificateUrl"
                                width="100%" height="500px" frameborder="0"></iframe>
                        </div>
                    </el-card>
                    <el-empty v-else description="暂无证书信息"></el-empty>
                </div>
            </div>
        </div>
        <site-footer />
    </div>
</template>

<script>
import { CertificateImgPc } from '@/api/apis'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
    name: 'ECertificate',
    components: {
        SiteHeader,
        SiteFooter
    },
    data() {
        return {
            certificates: []
        }
    },
    created() {
        this.fetchCertificates()
    },
    methods: {
        async fetchCertificates() {
            try {
                const response = await CertificateImgPc({
                    majorIds: [44, 46]
                })
                if (response.code === 200) {
                    this.certificates = response.rows
                } else {
                    this.$message.error(response.msg || '获取证书信息失败')
                }
            } catch (error) {
                console.error('获取证书信息失败:', error)
                this.$message.error('获取证书信息失败')
            }
        }
    }
}
</script>

<style scoped>
.page-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.main-content {
    flex: 1;
    background-color: #f5f7fa;
    padding: 20px 0;
}

.e-certificate {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.certificate-list {
    margin-top: 20px;
}

.certificate-card {
    margin-bottom: 20px;
}

.certificate-info {
    margin-bottom: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.info-item {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.info-item:last-child {
    margin-bottom: 0;
}

.label {
    font-weight: bold;
    width: 100px;
    color: #606266;
}

.value {
    color: #303133;
}

.certificate-preview {
    margin-top: 20px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
}
</style>